import FBody from '@/plugins/form/FBody';
import FDuration from '@/plugins/form/FDuration';
import FDateRange from '@/plugins/form/FDateRange';
import FTourDictionaryCity from '@/modules/Tour/Dictionary/City';
import FTourDictionaryDeparture from '@/modules/Tour/Dictionary/Departure';
import FTourDictionaryType from '@/modules/Tour/Dictionary/Type';
import FTourDictionaryName from '@/modules/Tour/Dictionary/Name';
import FTourDictionaryPartner from '@/modules/Tour/Dictionary/Partner';



export default class extends FBody {
  departure = new FTourDictionaryDeparture({
    label: 'Отправление',
    clearable: true,
  });

  city = new FTourDictionaryCity({
    label: 'Город',
    departure: this.departure,
    clearable: true,
  });

  partner =  new FTourDictionaryPartner({
    label: 'Юр. лицо',
    isMyAgency: true,
    clearable: true,
  });


  type = new FTourDictionaryType({
    label: 'Тип тура',
    clearable: true,
  });

  tour = new FTourDictionaryName({
    label: 'Название',
    clearable: true,
  });

  dates = new FDateRange({
    label: 'Начало тура',
    // min: dateYesterday,
    clearable: true,
  });

  duration = new FDuration({
    label: 'Продолжительность',
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['departure', this.departure],
      ['city', this.city],
      ['type', this.type],
      ['tour', this.tour],
      ['dates', this.dates],
      ['duration', this.duration],
      ['partner', this.partner],
    ]);
  }

  get data() {
    const data = super.data;
    return {
      DepartureId: data.departure || null,
      CityIds: data.city ? [data.city] : [],
      TourTypeId: data.type || null,
      TourId: data.tour || null,
      PartnerId: data.partner || null,
      'FromDate.Serialized': data.dates.from,
      'ToDate.Serialized': data.dates.to,
      FromDuration: data.duration.from,
      ToDuration: data.duration.to,

    };
  }

  set data(data) {
    data = data || {};
    this.departure.set(data.DepartureId ? {
      value: data.DepartureId,
    } : null);
    this.city.set({
      value: data.CityIds?.[0] ? data.CityIds[0] : null,
    });
    this.type.set(data.TourTypeId ? {
      value: data.TourTypeId,
    } : null);
    this.partner.set(data.PartnerId ? {
      value: data.PartnerId,
    } : null);
    this.tour.set(data.TourId ? {
      value: data.TourId,
    } : null);
    this.duration.set({
      from: data.FromDuration || 1,
      to: data.ToDuration || 1,
    });
    this.dates.setString({
      from: data['FromDate.Serialized'] || '',
      to: data['ToDate.Serialized'] || '',
    });
  }

  init() {
    const dateTo = new Date();
    dateTo.setDate(dateTo.getDate() + 30);
    this.dates.set({
      from: new Date(),
      to: dateTo,
    });
    this.duration.value.from = 0;
    this.duration.value.to = 7;
    return super.init();
  }
}
